module.exports = __webpack_public_path__ + "icomoon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/icomoon/icomoon.svg?1ki0q8
// module id = 655
// module chunks = 0